import omit from 'lodash/omit';

import { ModelConceptAttribute } from 'src/containers/ProjectDiagram/types/data';
import { Project, ProjectsState } from 'src/store/state/projects';
import { ReduxState } from 'src/store/types';

/**
 *  Migration to remove isSensitive property from the state
 */
// prevState must be typed as `any` since it's an older version of the Redux State
export const v11 = (prevState: any): ReduxState => {
  const nextState = { ...prevState };

  if (nextState.projects) {
    nextState.projects = v11Projects(prevState.projects);
  }

  return nextState;
};

const v11Projects = (prevProjectsState: any): ProjectsState => {
  const projectsById: Record<string, Project> = {};

  Object.entries(
    prevProjectsState.projectsById as Record<string, Project>
  ).forEach(([projectId, project]) => {
    if (!project.diagram) {
      projectsById[projectId] = project;
      return;
    }
    const attributesByIri: Record<string, ModelConceptAttribute> = {};

    Object.entries(project.diagram.model.modelData.attributesByIri).forEach(
      ([iri, attribute]) => {
        attributesByIri[iri] = omit(attribute, 'isSensitive');
      }
    );

    projectsById[projectId] = {
      ...project,
      diagram: {
        ...project.diagram,
        model: {
          ...project.diagram.model,
          modelData: {
            ...project.diagram.model.modelData,
            attributesByIri,
          },
        },
      },
    };
  });

  return { ...prevProjectsState, projectsById };
};
